import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2109a45c&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2109a45c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2109a45c')) {
      api.createRecord('2109a45c', component.options)
    } else {
      api.reload('2109a45c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2109a45c&lang=pug", function () {
      api.rerender('2109a45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/academy_talks/index.vue"
export default component.exports